var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePaginatedToggleButton',{attrs:{"label":"Routes","main-list":_vm.itemData,"is-global-percent":_vm.isGlobalPercent,"is-mark-active-item":"","override-headers":_vm.computedOverrideHeaders,"tabs-list":_vm.tabsList,"is-has-tabs":_vm.isHasTabs,"visible-pages-numbers":3},on:{"setActiveItem":_vm.setActiveRouteItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }